'use strict'

/**
 * Composant Newsletter
 */

import cleanTextOnFocus from 'Modules/cleanTextOnFocus'
import validationForm from 'Modules/validationForm'

const J_FORM_NEWSLETTER = '.j_form_newsletter'
const J_EMAIL_INPUT = 'input[name="j_email"]'
const J_ACTION_DATA = 'action'
const C_GREEN = 'green'
const C_RED = 'red'
const C_BLACK = 'black'

/**
 * Gère le submit de la newsletter
 */
$(J_FORM_NEWSLETTER).on('submit', function (event) {
    event.preventDefault()

    const form = $(this)

    validationForm.process(
        function (content) {
            // Callback de réussite
            $(J_EMAIL_INPUT).val(content.Message)
            cleanTextOnFocus.setEventOnCustomText(content.Message)
            manageStyleForNewsletterError(content.CssClass)
        },
        function (content) {
            // Callback si échec. C'est la même que la réussite : l'erreur est mis dans le champ email
            $(J_EMAIL_INPUT).val(content.Message)
            cleanTextOnFocus.setEventOnCustomText(content.Message)
            manageStyleForNewsletterError(content.CssClass)
        },
        function (msg) {
            // Callback exécuter si l'email n'a pas le bon format
            const content = {
                // Dans le cas du mail incorrect, on est pas passé dans l'ajax, il faut donc ajouter les éléments permettant de gérer les erreurs manuellement
                Error: true,
                CssClass: C_RED,
                Message: msg
            }
            $(J_EMAIL_INPUT).val(content.Message)
            cleanTextOnFocus.setEventOnCustomText(content.Message)
            manageStyleForNewsletterError(content.CssClass)
        },
        $(form).data(J_ACTION_DATA), // Le controller à appeler
        form
    )
})

/*
 * Gère les styles CSS à appliquer au champ newsletter selon le message
 */
function manageStyleForNewsletterError(cssClass) {
    $(J_EMAIL_INPUT).addClass(cssClass)
}

/*
 * Efface les couleurs des champs emails au focus
 */
$(J_EMAIL_INPUT).on('focus', function () {
    $(this).removeClass([C_GREEN, C_BLACK, C_RED])
})
